(function(){
  function rows(){
    var el=document.getElementById('ah-vc-data'); if(!el) return;
    var data; try{data=JSON.parse(el.textContent);}catch(e){return;}
    var picker=document.querySelector('.product__variant-picker'); if(!picker) return;
    var fs=picker.querySelector('fieldset.product-form__input--button'); if(!fs) return;
    picker.classList.add('ah-vc');
    var labels=fs.querySelectorAll('.product-option__label');
    for(var i=0;i<labels.length;i++){
      var lb=labels[i];
      if(lb.getAttribute('data-ah-vc')==='1') continue;
      var title=(lb.getAttribute('title')||'').trim(), row=null;
      for(var j=0;j<data.rows.length;j++){ if(data.rows[j].title===title){row=data.rows[j];break;} }
      if(!row) continue;
      var inner=lb.querySelector('span:not(.label-unavailable)');
      if(inner) inner.className='ah-vc__name';
      var right=document.createElement('span'); right.className='ah-vc__right';
      var p=document.createElement('span'); p.className='ah-vc__price'; p.textContent=row.price;
      right.appendChild(p);
      if(row.show){
        var s=document.createElement('span'); s.className='ah-vc__save';
        s.textContent=(data.save_label||'Save')+' '+row.save+' / '+row.pct+'%'; right.appendChild(s);
      }
      lb.appendChild(right);
      if(row.popular){
        lb.classList.add('ah-vc--pop');
        var b=document.createElement('span'); b.className='ah-vc__pop';
        b.textContent=(data.pop_label||'MOST POPULAR');
        lb.appendChild(b);
      }
      lb.setAttribute('data-ah-vc','1');
    }
  }

  function kit(){
    var tpl=document.getElementById('ah-kit-tpl'); if(!tpl) return;
    if(document.querySelector('.product__buy-buttons .ah-kit, .ah-kit[data-ah-placed]')) return;
    var anchor=document.querySelector('.product__buy-buttons'); if(!anchor) return;
    var node=tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-ah-placed','1');
    var after=anchor.nextElementSibling;
    if(!after || !after.classList.contains('ah-pdp-reassurance')) after=anchor;
    after.parentNode.insertBefore(node,after.nextSibling);
  }
  function run(){ rows(); kit(); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  document.addEventListener('shopify:section:load',run);
  var t=document.querySelector('.product__variant-picker');
  if(t){ new MutationObserver(run).observe(t,{childList:true,subtree:true}); }
})();
